<template>
  <div id="app">
    <headerComponent/>
    <router-view/>
    <footerComponent/>
  </div>
</template>
<script>
import headerComponent from '@/components/header'
import footerComponent from '@/components/footer'
export default {
  data() {
    return {}
  },
  components:{
    headerComponent,
    footerComponent,
    // Carousel,  
    // Slide
  },
  mounted() {
  },
}
</script>
<style lang="scss" scoped>
#app {
  // width: 100vw;
  // height: 100vh;
 
  overflow-x: hidden;
  min-width: 1450px;
  position: relative;
}
</style>
